import merge from "lodash/merge";

interface Env {
  readonly VITE_URL_ORIGINAL_WEBSITE: string;
  readonly VITE_URL_UPSTART_AI: string;
}

const getEnv = (): Env => {
  const conf = {
    VITE_URL_ORIGINAL_WEBSITE: "http://example.com",
    VITE_URL_UPSTART_AI: "",
  };
  merge(conf, import.meta.env);
  if (typeof window !== "undefined" && typeof window.env !== "undefined") {
    merge(conf, window.env);
  }
  return conf;
};

export const env = getEnv();
